"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMaxCharValidation = void 0;
var Localize_1 = require("../../gen-src/Localize");
var getTextValidity = function (current, maximum) {
    if (current.length > maximum) {
        return false;
    }
    // design calls for no green border, so 'valid' is just grey (undefined)
    return undefined;
};
/**
 * A function which returns a localized validation message and state for character count validation
 * @param maximum the maximum number of characters allowed
 * @param current the current value of the string to validate
 */
function getMaxCharValidation(current, maximum) {
    var isTextValid = getTextValidity(current, maximum);
    var message = Localize_1.Formatters.formatCount(current.length) + " / " + Localize_1.Formatters.formatCount(maximum);
    return { message: message, valid: isTextValid };
}
exports.getMaxCharValidation = getMaxCharValidation;
//# sourceMappingURL=MaxCharValidation.js.map